import { c as _c } from "react/compiler-runtime";
import { selectedProjectContextSelector, selectedProjectSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { hasUserValidFeatureProjectLevel, isUserPermittedToFeatureProjectLevel } from "@utils/feature-control/project/project-feature-control";
import { RequiredFeatureProjectLevelName } from "@utils/feature-control/project/project-feature-control-types";
import { useCallback, useMemo } from "react";
/** Checks whether a user has permission for an action on project level or not */
export function useHasValidFeatureProjectLevel(t0) {
  const $ = _c(39);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    featuresAvailable: t2
  } = t1;
  const featuresAvailable = t2 === undefined ? undefined : t2;
  const selectedProjectInStore = useAppSelector(selectedProjectSelector);
  const projectContext = useAppSelector(selectedProjectContextSelector);
  projectContext?.featuresAvailable;
  selectedProjectInStore?.featuresAvailable;
  const availableFeatures = featuresAvailable ?? selectedProjectInStore?.featuresAvailable ?? projectContext?.featuresAvailable;
  let t3;
  if ($[2] !== availableFeatures) {
    t3 = hasUserValidFeatureProjectLevel({
      roleName: RequiredFeatureProjectLevelName.canArchiveProject,
      featuresAvailable: availableFeatures
    });
    $[2] = availableFeatures;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const canArchiveProject = t3;
  let t4;
  if ($[4] !== availableFeatures) {
    t4 = hasUserValidFeatureProjectLevel({
      roleName: RequiredFeatureProjectLevelName.canUnarchiveProject,
      featuresAvailable: availableFeatures
    });
    $[4] = availableFeatures;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const canUnarchiveProject = t4;
  let t5;
  if ($[6] !== availableFeatures) {
    t5 = isUserPermittedToFeatureProjectLevel({
      roleName: RequiredFeatureProjectLevelName.canView2dImagesFeature,
      featuresAvailable: availableFeatures
    });
    $[6] = availableFeatures;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const canView2dImagesFeature = t5;
  let t6;
  if ($[8] !== availableFeatures) {
    t6 = isUserPermittedToFeatureProjectLevel({
      roleName: RequiredFeatureProjectLevelName.canViewVideoModeFeature,
      featuresAvailable: availableFeatures
    });
    $[8] = availableFeatures;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const canViewVideoModeFeature = t6;
  let t7;
  if ($[10] !== availableFeatures) {
    t7 = isUserPermittedToFeatureProjectLevel({
      roleName: RequiredFeatureProjectLevelName.canViewFaceBlurringFeature,
      featuresAvailable: availableFeatures
    });
    $[10] = availableFeatures;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const canViewFaceBlurringFeature = t7;
  let t8;
  if ($[12] !== availableFeatures) {
    t8 = isUserPermittedToFeatureProjectLevel({
      roleName: RequiredFeatureProjectLevelName.canViewFaceBlurringV1Feature,
      featuresAvailable: availableFeatures
    });
    $[12] = availableFeatures;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const canViewFaceBlurringV1Feature = t8;
  let t9;
  if ($[14] !== availableFeatures) {
    t9 = isUserPermittedToFeatureProjectLevel({
      roleName: RequiredFeatureProjectLevelName.canViewAiIndexingFeature,
      featuresAvailable: availableFeatures
    });
    $[14] = availableFeatures;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const canViewAiIndexingFeature = t9;
  const hasFeatureProjectLevel = _temp;
  let t10;
  if ($[16] !== availableFeatures) {
    t10 = hasUserValidFeatureProjectLevel({
      roleName: RequiredFeatureProjectLevelName.canDownloadProject,
      featuresAvailable: availableFeatures
    });
    $[16] = availableFeatures;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const canDownloadProject = t10;
  let t11;
  if ($[18] !== availableFeatures) {
    t11 = hasUserValidFeatureProjectLevel({
      roleName: RequiredFeatureProjectLevelName.canManageProjectIntegrations,
      featuresAvailable: availableFeatures
    });
    $[18] = availableFeatures;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const canManageProjectIntegrations = t11;
  let t12;
  if ($[20] !== availableFeatures) {
    t12 = hasUserValidFeatureProjectLevel({
      roleName: RequiredFeatureProjectLevelName.canExportProject,
      featuresAvailable: availableFeatures
    });
    $[20] = availableFeatures;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const canExportProject = t12;
  let t13;
  if ($[22] !== availableFeatures) {
    t13 = hasUserValidFeatureProjectLevel({
      roleName: RequiredFeatureProjectLevelName.canCreateSnapshot,
      featuresAvailable: availableFeatures
    });
    $[22] = availableFeatures;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const canCreateSnapshot = t13;
  let t14;
  if ($[24] !== availableFeatures) {
    t14 = hasUserValidFeatureProjectLevel({
      roleName: RequiredFeatureProjectLevelName.canAssignProjectRoles,
      featuresAvailable: availableFeatures
    });
    $[24] = availableFeatures;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const canAssignProjectRoles = t14;
  let t15;
  if ($[26] !== canArchiveProject || $[27] !== canAssignProjectRoles || $[28] !== canCreateSnapshot || $[29] !== canDownloadProject || $[30] !== canExportProject || $[31] !== canManageProjectIntegrations || $[32] !== canUnarchiveProject || $[33] !== canView2dImagesFeature || $[34] !== canViewAiIndexingFeature || $[35] !== canViewFaceBlurringFeature || $[36] !== canViewFaceBlurringV1Feature || $[37] !== canViewVideoModeFeature) {
    t15 = {
      canArchiveProject,
      canUnarchiveProject,
      canView2dImagesFeature,
      canViewVideoModeFeature,
      canViewFaceBlurringFeature,
      canViewFaceBlurringV1Feature,
      canViewAiIndexingFeature,
      hasFeatureProjectLevel,
      canDownloadProject,
      canManageProjectIntegrations,
      canExportProject,
      canCreateSnapshot,
      canAssignProjectRoles
    };
    $[26] = canArchiveProject;
    $[27] = canAssignProjectRoles;
    $[28] = canCreateSnapshot;
    $[29] = canDownloadProject;
    $[30] = canExportProject;
    $[31] = canManageProjectIntegrations;
    $[32] = canUnarchiveProject;
    $[33] = canView2dImagesFeature;
    $[34] = canViewAiIndexingFeature;
    $[35] = canViewFaceBlurringFeature;
    $[36] = canViewFaceBlurringV1Feature;
    $[37] = canViewVideoModeFeature;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
}
function _temp(t0) {
  const {
    roleName,
    featuresAvailable: featuresAvailable_0
  } = t0;
  return hasUserValidFeatureProjectLevel({
    roleName,
    featuresAvailable: featuresAvailable_0
  });
}